module.exports = __webpack_public_path__ + "img/logo-dark.36083d01.png";